module.exports = __webpack_public_path__ + "assets/img/look_explain.eb60b143.png";